<ng-template #template>
    <div class="modal-header">
        <h5 class="modal-title">Compila Foglio di Marcia</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="modalRef.hide()">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>
    <div class="modal-body">


        <div style="margin-bottom: 10px; text-align:center;"><b >viaggio # {{travelToCompile.id}}</b></div>
        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon165">Targa</span>
            </div>
            <input type="text" class="form-control" placeholder="Targa"
                   [ngModel]="travelToCompile.vehicle.plate"
                   aria-label="Targa" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon16">Marca</span>
            </div>
            <input type="text" class="form-control" placeholder="Marca"
                   [ngModel]="travelToCompile.vehicle.model.brand.name"
                   aria-label="Marca" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text" id="basic-addon17">Modello</span>
            </div>
            <input type="text" class="form-control" placeholder="Modello"
                   [ngModel]="travelToCompile.vehicle.model.name"
                   aria-label="Modello" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-1">
            <div class="input-group-prepend">
                <span class="input-group-text">Classe</span>
            </div>
            <input type="text" class="form-control" placeholder="Classe"
                   [ngModel]="travelToCompile.vehicle.type.name"
                   aria-label="Classe" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Sottoclasse</span>
            </div>
            <input type="text" class="form-control"
                   placeholder="Sottoclasse" [(ngModel)]="travelToCompile.vehicle.type.supertype.name"
                   aria-label="Sottoclasse" aria-describedby="basic-addon1" disabled>
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text" >Km</span>
            </div>
            <input type="number" min="1" max="999999" class="form-control"
                   placeholder="Kilometri attuali" [(ngModel)]="travelToCompile.start_kilometers"
                   aria-label="Kilometri attuali" aria-describedby="basic-addon1"
                   [disabled]="travelToCompile.travelStarted()">
        </div>

        <div class="input-group mb-3">
            <div class="input-group-prepend">
                <span class="input-group-text">Data</span>
            </div>
            <input type="text"
                   class="form-control"
                   #dp="bsDatepicker"
                   style="height: auto;"
                   bsDatepicker
                   [bsConfig]="{dateInputFormat: 'D/MM/YYYY', showWeekNumbers: false}"
                   [(bsValue)]="travelToCompile.started_at_app" [disabled]="travelToCompile.travelStarted()"
                   [maxDate]="maxDate"
                   (bsValueChange)="onDateChange($event)">
            <timepicker [(ngModel)]="travelToCompile.started_at_app" (ngModelChange)="onDateChange($event)" [showMeridian]="false"
                        [disabled]="travelToCompile.travelStarted()" [max]="maxDate"></timepicker>
        </div>

        <div class="form-group">
            <label for="prime_segnalazioni">Prime segnalazioni</label>
            <textarea class="form-control height250"  id="prime_segnalazioni"
                      [(ngModel)]="travelToCompile.first_reporting" maxlength="250"
                      [disabled]="travelToCompile.travelStarted()"></textarea>
        </div>

        <div class="form-group">
            <label for="motivazione2">Motivazione - Luogo</label>
            <textarea class="form-control height250"  id="motivazione2"
                      [(ngModel)]="travelToCompile.motivation === 3 ? travelToCompile.motivation_other : travelToCompile.motivation_name" disabled maxlength="250"></textarea>
        </div>

        <div class="form-group">
            <label for="passengers">Persone Trasportate</label>
            <textarea class="form-control height250"  id="passengers"
                      [(ngModel)]="travelToCompile.passengers" disabled maxlength="250"></textarea>
        </div>

    </div><!-- end modal body-->
    <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="modalRef.hide()">Annulla</button>
        <button type="button"
                class="btn btn-secondary"
                [disabled]="dom_elements.assign_btn.is_running || travelToCompile.travelStarted()"
                data-dismiss="modal"
                (click)="sendWarrant()">
            {{ dom_elements.assign_btn.is_running ?
            dom_elements.assign_btn.txt_run :
            dom_elements.assign_btn.txt_not_run}}
        </button>
    </div>
</ng-template>
